import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ImplicitAuthWidget } from 'containers/ImplicitAuthWidget';
import { setAuthTimestamp } from 'utils/authTimestampUtils';

export const ProdStackManagerContentGuest = () => {
  const dispatch = useAppDispatcher();

  const handleEmailConfirmed = React.useCallback(() => {
    dispatch({
      name: 'ProdStackManager__EmailConfirmed',
    });
  }, [dispatch]);

  React.useLayoutEffect(() => {
    setAuthTimestamp(new Date().toISOString());
  }, []);

  return (
    <ImplicitAuthWidget target="PROD" onEmailConfirmed={handleEmailConfirmed} />
  );
};
